export const responsibleOptions = [
	{
		type: 'Padrão do Sistema',
		options: [['Não alterar responsável do cliente, apenas do negócio.', 'none']]
	},
	{
		type: 'Apenas para Administradores e Colaboradores',
		options: [
			['Ao alterar responsável do negócio, alterar tambem do cliente.', 'onlyAdmin'],
			[
				'Ao alterar responsável do negócio, perguntar se quer alterar também do cliente.',
				'onlyAdminAsk'
			]
		]
	},
	{
		type: 'Todos os Perfis',
		options: [
			['Ao alterar responsável do negócio, alterar tambem do cliente.', 'all'],
			[
				'Ao alterar responsável do negócio, perguntar se quer alterar também do cliente.',
				'ask'
			]
		]
	}
]
